import { MAX_POOL_NAME_LENGTH } from '../pages/portfolio/CreatePoolForm';

/**
 * Pure helpers shared by the two tape-pool surfaces — `PoolFromTapeButton`
 * (rendered as the saved-overlay secondary action) and `LatestUploadBanner`
 * (loan-datatable). Anything that formats the suggested pool name or the
 * loan-count UI copy lives here so a fix lands in one place.
 */

const isoLocalDate = (now: Date): string => {
  // en-CA produces YYYY-MM-DD in user's local time, matching the user's
  // mental model of "the day I uploaded" rather than UTC.
  return new Intl.DateTimeFormat('en-CA').format(now);
};

const stripFileExtension = (s: string): string => s.replace(/\.(csv|xlsx|xls|tsv|txt)$/i, '');

export const buildSuggestedPoolName = (tapeName: string, now: Date): string => {
  const date = isoLocalDate(now);
  const cleanName = stripFileExtension(tapeName).trim();
  const suffix = ` Pool — ${date}`;
  const room = Math.max(0, MAX_POOL_NAME_LENGTH - suffix.length);
  if (room === 0) return suffix.trimStart();
  const trimmed =
    cleanName.length > room ? `${cleanName.slice(0, room - 1).trimEnd()}…` : cleanName;
  return `${trimmed}${suffix}`;
};

export const formatLoanCount = (count: number): string => {
  return new Intl.NumberFormat(undefined).format(count);
};

export const pluralizeLoans = (count: number): string => (count === 1 ? 'loan' : 'loans');
